/**
 * Builds page items for numbered pagination (max N page buttons when total is large).
 * @returns {(number|'ellipsis')[]}
 */
export function getPaginationItems(currentPage, totalPages, { maxPageButtons = 10 } = {}) {
  if (totalPages < 1) return [];
  if (totalPages <= maxPageButtons) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const innerCount = maxPageButtons - 2;
  let start = Math.max(2, currentPage - Math.floor(innerCount / 2));
  let end = start + innerCount - 1;
  if (end >= totalPages) {
    end = totalPages - 1;
    start = Math.max(2, end - innerCount + 1);
  }

  const items = [1];
  if (start > 2) items.push('ellipsis');
  for (let p = start; p <= end; p += 1) items.push(p);
  if (end < totalPages - 1) items.push('ellipsis');
  items.push(totalPages);
  return items;
}
